import { useQuery } from "react-query";
import {
  CustomModal,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../../../../../components";
import Context from "../../../../../../context";
import values from "../../../../../../values";
import api from "../../../../../../api";
import React, { useState } from "react";
import utils from "../../../../../../utils";
import {
  PAY_TYPE,
  RECEIVER_TYPE,
  TRANSACTION_STATUS,
} from "../../../../../../values/dropdownItems";
import "./index.scss";
import { useTranslation } from "react-i18next";

const MicroTransaction = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedTransaction } = React.useContext(
    Context.TransactionsScreen
  );
  const [page, setPage] = useState<number>(1);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! ----------------------------------------------------------------------------------------------------------

  const getMicroTransactions = useQuery(
    [values.useQueryKeys.getMicroTransactions, page, selectedTransaction],
    () =>
      api.post.common.findMicroTransaction({
        page: page,
        limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
        transactionId: selectedTransaction?._id,
      })
  );
  const { data, status } = getMicroTransactions;

  const { t } = useTranslation();

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "MICRO_TRANSACTIONS"}
      minWidth={"40vw"}
    >
      <>
        {selectedTransaction?.description && (
          <p className="transaction-description">
            <span>{t("description")} : </span>{" "}
            {selectedTransaction?.description}
          </p>
        )}
        <h6>{t("microTransactions")}</h6>
        <table>
          <TableHeader
            headers={values.tableHeaders.MICRO_TRANSACTION_TABLE_HEADER}
          />
          {status === "loading" && <TableLoading />}
          <tbody>
            {status === "success" &&
              data?.result?.docs?.map((invoice: any, index: number) => {
                return (
                  <tr key={`parent-${index}`}>
                    <td
                      className="pointer"
                      // onClick={() => onClick(parent)}
                    >
                      {index + 1}
                    </td>
                    {/* actions */}
                    <td>
                      {utils.convertNumberToPrice(invoice?.amount)} {t("toman")}
                    </td>
                    <td>
                      {
                        PAY_TYPE?.find(
                          (item) => item.value === invoice?.isDeposit
                        )?.name
                      }
                    </td>
                    <td>
                      {
                        RECEIVER_TYPE.find(
                          (item) => item._id === invoice?.receiverType
                        )?.name
                      }
                    </td>
                    <td>
                      {
                        TRANSACTION_STATUS?.find(
                          (item) => item?.value === invoice?.transactionStatus
                        )?.name
                      }
                    </td>

                    {/* <td>
                          <div className="table-actions-buttons">
                            <CustomIcon
                              icon="fa fa-credit-card"
                              hoverTitle="پرداخت"
                              
                            />
    
                          </div>
                        </td> */}
                  </tr>
                );
              })}
          </tbody>
        </table>
        {status === "success" && data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setPage(page)}
            />
          </div>
        )}
      </>
    </CustomModal>
  );
};

export default MicroTransaction;
